import React, { useEffect, useState } from "react";
import { useWindowScroll } from "react-use";
import "./scrollindicator.scss";
const ScrollIndecator = () => {
  const { x, y } = useWindowScroll();
  const [scrolled, setScrolled] = useState(0);
  const [scrolledNew, newScrolled] = useState(0);
  useEffect(() => {
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    setScrolled((y / height) * 100);
    // console.log(parseInt(scrolled));
    let progressValue = parseInt(scrolled);
    if (progressValue > 100) progressValue = 100;
    else if (progressValue < 0) progressValue = 0;
    else progressValue = Math.round(progressValue / 10) * 10;
    newScrolled(progressValue);
  }, [y]);
  return (
    <section>
      <div
        className="scroll-container"
        style={{ backgroundPosition: `-10%`}}
      ></div>
    </section>
  );
};

export default ScrollIndecator;
